import { useCurrentUser, useRbacPrimaryRolePermissions } from "../../api/hooks";
import { useFeatureFlagQuery } from "../../hooks/useFeatureFlag";

export const useCompensationAccess = (cycleId: string | undefined) => {
	const { data: currentUser, isLoading: isCurrentUserLoading } = useCurrentUser();
	const userID = currentUser?.me?.authorization?.payload?.user_id;

	const { value: compensationEnabled, query: featureFlagQuery } = useFeatureFlagQuery("ff-compensation", undefined);
	const { data: permissions, isLoading: isPermissionsLoading } = useRbacPrimaryRolePermissions("compensation");

	const isLoading =
		isCurrentUserLoading ||
		isPermissionsLoading ||
		(compensationEnabled === undefined && !featureFlagQuery.isError);

	const canMakeDecisions = Boolean(permissions?.includes("compensation:makeDecisions"));
	const canViewCycles = Boolean(permissions?.includes("compensation:viewCycles"));
	const canViewCyclesWithDecisionsToMake = Boolean(
		permissions?.includes("compensation:viewCyclesWithDecisionsToMake")
	);
	const canCreateCycle = Boolean(permissions?.includes("compensation:createCycle"));
	const canDeleteCycle = Boolean(permissions?.includes("compensation:deleteCycle"));
	const canViewCompensation = compensationEnabled === true && (canViewCycles || canViewCyclesWithDecisionsToMake);
	const canAlwaysViewSalary = Boolean(permissions?.includes("compensation:canAlwaysViewSalary"));
	const compensationDisabled = compensationEnabled === false || featureFlagQuery.isError;

	const canLoadMyDecisions = Boolean(userID && cycleId) && canMakeDecisions && compensationEnabled === true;

	return {
		userID,
		permissions,
		isLoading,
		compensationEnabled,
		compensationDisabled,
		canMakeDecisions,
		canViewCycles,
		canViewCyclesWithDecisionsToMake,
		canCreateCycle,
		canViewCompensation,
		canLoadMyDecisions,
		canDeleteCycle,
		canAlwaysViewSalary,
	};
};
